import React from "react";
import { Menu } from "lucide-react";

const HamburgerButton = ({ onClick, className = "" }) => {
  return (
    <button
      className={`p-2 rounded-lg hover:bg-gray-100 cursor-pointer transition-colors ${className}`}
      onClick={onClick}
      aria-label="Toggle sidebar"
    >
      <Menu size={22} className="text-gray-600" />
    </button>
  );
};

export default HamburgerButton;
